import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import { appSagas } from './AppModule';
import loginState, { loginSagas } from './LoginModule';
import { apiSagas } from './ApiModule';
import blockDisplayState from './BlockDisplayModule';
import notificationState, { notificationSagas } from './NotificationModule';
import subjectSearchState, { subjectSearchSagas } from './body/subject/SubjectSearchModule';
import systemCommonCodeState, { systemCommonCodeSagas } from './body/system/SystemCommonCodeModule';
import errorPopupState from './ErrorPopupModule';
import { semesterSubjectSagas } from './body/semester/SemesterSubjectModule';
import { systemUniversitySagas } from './body/system/SystemUniversityModule';
import { systemUniversityManagerSagas } from './body/system/SystemUniversityManagerModule';
import semesterStudentUniversityState, {
    semesterStudentUniversitySagas,
} from './body/semester/SemesterStudentUniversityModule';
import semesterStudentEnrolmentCheckViewTab1BodyState, {
    semesterStudentEnrolmentCheckViewTab1BodySagas,
} from './body/semester/SemesterStudentEnrolmentCheckViewTab1BodyModule';
import semesterStudentEnrolmentCheckViewTab2BodyState, {
    semesterStudentEnrolmentCheckViewTab2BodySagas,
} from './body/semester/SemesterStudentEnrolmentCheckViewTab2BodyModule';
import enrolmentSearchSubjectState, {
    enrolmentSearchSubjectSagas,
} from './body/enrolment/EnrolmentSearchSubjectModule';
import pdfViewState, { pdfViewSagas } from './modal/PdfViewModule';
import enrolmentCautionState, { enrolmentCautionSagas } from './modal/EnrolmentCautionModule';
import enrolmentResultState, { enrolmentResultSagas } from './body/enrolment/EnrolmentEnrolmentResultModule';
import { systemTermSagas } from './body/system/SystemTermModule';
import scheduleState, { scheduleSagas } from './component/ScheduleModule';
import findIdPwState, { findIdPwSagas } from './body/main/FindIdPwModule';
import passwordResetState, { passwordResetSagas } from './body/main/PasswordResetModule';
import { systemSubjectCodeSagas } from './body/system/SystemSubjectCodeModule';
import { communityNoticeSagas } from './body/community/notice/CommunityNoticeModule';
import { communityFaqSagas } from './body/community/faq/CommunityFaqModule';
import { communityQnaSagas } from './body/community/qna/CommunityQnaModule';
import joinUsPhase2State, { joinUsPhase2Sagas } from './body/main/JoinUsPhase2Module';
import { joinUsPhase3Sagas } from './body/main/JoinUsPhase3Module';
import userInfoState, { userInfoSagas } from './body/main/UserInfoModule';
import semesterEnrolmentStatusViewTab1BodyState, {
    semesterEnrolmentStatusViewTab1BodySagas,
} from './body/semester/SemesterEnrolmentStatusViewTab1BodyModule';
import semesterEnrolmentStatusViewTab2BodyState, {
    semesterEnrolmentStatusViewTab2BodySagas,
} from './body/semester/SemesterEnrolmentStatusViewTab2BodyModule';
import subjectDetailState, { subjectDetailSagas } from './modal/SubjectDetailModule';
import tableBoxState from './component/TableBoxModule';
import tableNoPageBoxState from './component/TableNoPageBoxModule';
import fileAttachState, { fileAttachSagas } from './component/FileAttachModule';
import noticePopupState, { noticePopupSagas } from './component/NoticePopupModule';
import subjectCodeSearchState, { subjectCodeSearchSagas } from './modal/SubjectCodeSearchModule';
import { systemUserSagas } from './body/system/SystemUserModule';
import { systemLoginHistorySagas } from './body/system/SystemLoginHistoryModule';
import { smsHistorySagas } from './body/sms/SmsHistoryModule';
import smsSendState, { smsSendSagas } from './body/sms/SmsSendModule';
import { semesterTotalEnrolmentStatusSagas } from './body/semester/SemesterTotalEnrolmentStatusModule';
import semesterEnrolmentManagementState, { semesterEnrolmentManagementSagas } from './body/semester/SemesterEnrolmentManagementModule';

const rootReducer = combineReducers({
    loginState,
    blockDisplayState,
    notificationState,
    errorPopupState,
    systemCommonCodeState,
    subjectSearchState,
    semesterStudentUniversityState,
    semesterStudentEnrolmentCheckViewTab1BodyState,
    semesterStudentEnrolmentCheckViewTab2BodyState,
    enrolmentSearchSubjectState,
    pdfViewState,
    enrolmentCautionState,
    enrolmentResultState,
    scheduleState,
    findIdPwState,
    passwordResetState,
    joinUsPhase2State,
    userInfoState,
    semesterEnrolmentStatusViewTab1BodyState,
    semesterEnrolmentStatusViewTab2BodyState,
    subjectDetailState,
    tableBoxState,
    tableNoPageBoxState,
    fileAttachState,
    noticePopupState,
    subjectCodeSearchState,
    smsSendState,
    semesterEnrolmentManagementState,
});

export function* rootSaga() {
    yield all([
        appSagas(),
        loginSagas(),
        apiSagas(),
        notificationSagas(),
        systemCommonCodeSagas(),
        subjectSearchSagas(),
        semesterSubjectSagas(),
        systemUniversitySagas(),
        systemUniversityManagerSagas(),
        semesterStudentUniversitySagas(),
        semesterStudentEnrolmentCheckViewTab1BodySagas(),
        semesterStudentEnrolmentCheckViewTab2BodySagas(),
        enrolmentSearchSubjectSagas(),
        pdfViewSagas(),
        enrolmentCautionSagas(),
        enrolmentResultSagas(),
        systemTermSagas(),
        scheduleSagas(),
        findIdPwSagas(),
        passwordResetSagas(),
        systemSubjectCodeSagas(),
        communityNoticeSagas(),
        communityFaqSagas(),
        communityQnaSagas(),
        joinUsPhase2Sagas(),
        joinUsPhase3Sagas(),
        userInfoSagas(),
        semesterEnrolmentStatusViewTab1BodySagas(),
        semesterEnrolmentStatusViewTab2BodySagas(),
        semesterTotalEnrolmentStatusSagas(),
        subjectDetailSagas(),
        fileAttachSagas(),
        noticePopupSagas(),
        subjectCodeSearchSagas(),
        systemUserSagas(),
        systemLoginHistorySagas(),
        smsSendSagas(),
        smsHistorySagas(),
        semesterEnrolmentManagementSagas(),
    ]);
}

export default rootReducer;
